
import ContentLoader from "react-content-loader";
const ModalLoaderReserve = () => {
    return (
        <div className="loaderHolder">
            <div>
                <ContentLoader
                    height={50}
                    width={800}
                    speed={1}
                    backgroundColor="#f3f3f3"
                    foregroundColor="#d7dbd8"

                >
                    <rect x="0" y="10" rx="0" ry="2" width={800} height="100" />
                </ContentLoader>
            </div>
            <br />
            <div>
                <ContentLoader
                    height={50}
                    width={200}
                    speed={1}
                    backgroundColor="#f3f3f3"
                    foregroundColor="#d7dbd8"

                >
                    <rect x="0" y="10" rx="0" ry="2" width={800} height="100" />
                </ContentLoader>
            </div>
            <br />
            <div className="d-flex justify-content-between">
                <span>
                    <ContentLoader
                        height={50}
                        width={400}
                        speed={1}
                        backgroundColor="#f3f3f3"
                        foregroundColor="#d7dbd8"

                    >
                        <rect x="0" y="10" rx="0" ry="2" width={800} height="100" />
                    </ContentLoader>
                </span>
                <span>
                    <ContentLoader
                        height={50}
                        width={400}
                        speed={1}
                        backgroundColor="#f3f3f3"
                        foregroundColor="#d7dbd8"

                    >
                        <rect x="0" y="10" rx="0" ry="2" width={800} height="100" />
                    </ContentLoader>
                </span>

            </div>
            <br />
            <div className="d-flex justify-content-between">
                <span>
                    <ContentLoader
                        height={50}
                        width={400}
                        speed={1}
                        backgroundColor="#f3f3f3"
                        foregroundColor="#d7dbd8"

                    >
                        <rect x="0" y="10" rx="0" ry="2" width={800} height="100" />
                    </ContentLoader>
                </span>
                <span>
                    <ContentLoader
                        height={50}
                        width={400}
                        speed={1}
                        backgroundColor="#f3f3f3"
                        foregroundColor="#d7dbd8"

                    >
                        <rect x="0" y="10" rx="0" ry="2" width={800} height="100" />
                    </ContentLoader>
                </span>

            </div>
            <br />
            <div className="d-flex justify-content-between">
                <span>
                    <ContentLoader
                        height={50}
                        width={400}
                        speed={1}
                        backgroundColor="#f3f3f3"
                        foregroundColor="#d7dbd8"

                    >
                        <rect x="0" y="10" rx="0" ry="2" width={800} height="100" />
                    </ContentLoader>
                </span>
                <span>
                    <ContentLoader
                        height={50}
                        width={400}
                        speed={1}
                        backgroundColor="#f3f3f3"
                        foregroundColor="#d7dbd8"

                    >
                        <rect x="0" y="10" rx="0" ry="2" width={800} height="100" />
                    </ContentLoader>
                </span>

            </div>
            <br />
            <div className="d-flex justify-content-between">
                <span>
                    <ContentLoader
                        height={100}
                        width={400}
                        speed={1}
                        backgroundColor="#f3f3f3"
                        foregroundColor="#d7dbd8"

                    >
                        <rect x="0" y="10" rx="0" ry="2" width={800} height="100" />
                    </ContentLoader>
                </span>
                <div className="d-flex justify-content-between " style={{ margin: '0  15px 0 0' }}>
                    <span>
                        <ContentLoader
                            height={50}
                            width={400}
                            speed={1}
                            backgroundColor="#f3f3f3"
                            foregroundColor="#d7dbd8"

                        >
                            <rect x="0" y="10" rx="0" ry="2" width={800} height="100" />
                        </ContentLoader>
                        <ContentLoader
                            height={50}
                            width={400}
                            speed={1}
                            backgroundColor="#f3f3f3"
                            foregroundColor="#d7dbd8"

                        >
                            <rect x="0" y="10" rx="0" ry="2" width={800} height="100" />
                        </ContentLoader>
                    </span>
                </div>


            </div>
            <br />
            <br />
            <div className="d-flex justify-content-end">
                <span>
                    <ContentLoader
                        height={50}
                        width={200}
                        speed={1}
                        backgroundColor="#f3f3f3"
                        foregroundColor="#d7dbd8"

                    >
                        <rect x="0" y="10" rx="0" ry="2" width={800} height="100" />
                    </ContentLoader>
                </span>

            </div>


        </div>




    )
}
export default ModalLoaderReserve;